import { CalendarDateIcon, FileDownload01Icon, Tag01Icon } from "@vetty/icons";
import { Button, Select, Tabs, TabsItem } from "@/components";
import {
  CHANGELOG_PERIOD_OPTIONS,
  CHANGELOG_TAB_ITEMS,
  CHANGELOG_TRACK_OPTIONS,
  type ChangelogPeriodFilter,
  type ChangelogToolbarTab,
  type ChangelogTrackFilter,
} from "../../_constants/changelog-toolbar.const";
import styles from "./ChangelogToolbar.module.scss";

type ChangelogToolbarProps = {
  tab: ChangelogToolbarTab;
  period: ChangelogPeriodFilter;
  track: ChangelogTrackFilter;
  onTabChange: (value: ChangelogToolbarTab) => void;
  onPeriodChange: (value: ChangelogPeriodFilter) => void;
  onTrackChange: (value: ChangelogTrackFilter) => void;
  onExportClick: () => void;
};

export const ChangelogToolbar = ({
  tab,
  period,
  track,
  onTabChange,
  onPeriodChange,
  onTrackChange,
  onExportClick,
}: ChangelogToolbarProps) => {
  return (
    <div className={styles["comp"]}>
      <div className={styles["comp__left"]}>
        <Tabs
          value={tab}
          onChange={(value) => onTabChange(value as ChangelogToolbarTab)}
          variant="secondary"
          size="medium"
        >
          {CHANGELOG_TAB_ITEMS.map((item) => (
            <TabsItem key={item.value} value={item.value}>
              {item.label}
            </TabsItem>
          ))}
        </Tabs>

        <div className={styles["comp__filters"]}>
          <Select
            size="medium"
            variant="secondary"
            value={period}
            startContent={<CalendarDateIcon style={{ width: 20, height: 20 }} />}
            onChange={(value) => onPeriodChange(value as ChangelogPeriodFilter)}
          >
            {CHANGELOG_PERIOD_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>

          <Select
            size="medium"
            variant="secondary"
            value={track}
            startContent={<Tag01Icon style={{ width: 20, height: 20 }} />}
            onChange={(value) => onTrackChange(value as ChangelogTrackFilter)}
          >
            {CHANGELOG_TRACK_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Select>
        </div>
      </div>

      <div className={styles["comp__actions"]}>
        <Button
          size="medium"
          variant="primary"
          startContent={<FileDownload01Icon style={{ width: 20, height: 20 }} />}
          onClick={onExportClick}
        >
          Export
        </Button>
      </div>
    </div>
  );
};
